import { publicService } from '@/api/services';

import type { UnwrapData } from '../../types';

import type { IFeatureFlagsResponse } from './types';

export const featureFlagsService = publicService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить список динамических фича флагов
     */
    getFeaturesFlags: builder.query<UnwrapData<IFeatureFlagsResponse>, void>({
      query: () => ({
        method: 'GET',
        url: '/feature_flags',
      }),
      transformResponse: (response: IFeatureFlagsResponse) => response.data,
    }),
  }),
});

export const { useGetFeaturesFlagsQuery } = featureFlagsService;
